import React from "react";

// Decorative radial glow "wave" used behind hero/section-transition areas.
const GlowBackdrop = ({ variant = "hero" }) => {
  if (variant === "hero") {
    return (
      <div className="absolute inset-0 overflow-hidden pointer-events-none" aria-hidden="true">
        <div
          className="absolute top-[-10%] left-[10%] w-[600px] h-[600px] rounded-full blur-3xl opacity-40 animate-float-slow"
          style={{ background: "radial-gradient(circle, rgba(255, 0, 15,0.35), transparent 70%)" }}
        />
        <div
          className="absolute top-[10%] right-[5%] w-[500px] h-[500px] rounded-full blur-3xl opacity-30 animate-float-slow"
          style={{ background: "radial-gradient(circle, rgba(210, 0, 26,0.28), transparent 70%)", animationDelay: "2s" }}
        />
      </div>
    );
  }
  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none" aria-hidden="true">
      <div
        className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[900px] h-[300px] rounded-full blur-3xl opacity-20"
        style={{ background: "radial-gradient(ellipse, rgba(255, 0, 15,0.25), transparent 70%)" }}
      />
    </div>
  );
};

export default GlowBackdrop;
